import React, { Component } from 'react';

class Main extends Component {
    state = { 
        timeElapsed : 0,
        text : "",
        score: 0,
        currentscore: 0,
        isPlaying: false,
        levelsecond: 5,
        message: "",
        currentword: "paradox",
        words:[
            "window",
            "beautiful",
            "web",
            "better",
            "river",
            "generete",
            "runaway",
            "joke",
            "hero",
            "javascript",
            "nutrition",
            "revolver",
            "siblings",
            "investigate",
            "horrendous",
            "dangerous",
            "thousand",
            "billioner",
            "establishment",
            "laughter"
        ]
     }

     // Show random word
     showWord(words){
         const randIndex = Math.floor(Math.random() * this.state.words.length)
         // output random word
        this.setState({ currentword: words[randIndex]  }); 
     }

    // times
    elapsedTime() {
        var timeElapsed = Math.floor((new Date() - this.state.start)/ 1000);
        this.setState({ timeElapsed: timeElapsed  });

        if (this.state.elapsedTime >= 5) {
            clearInterval(this.interval);
        }
    }
    
    //Countdown Timer 
    timer(time) {
        
        let timer = this.state.levelsecond - time
        if ( timer > 0 && timer <= 5) {
             return timer
        }else if (timer < 0) {
            return timer = 0
        }else if (timer === 0) {
            return timer = 0 
        }
    }

    //Check status game
    checkStatus(){
        if (!this.state.isPlaying && this.timer(this.state.timeElapsed) === 0) {
           this.setState({ message: "Game over!!!" });
           this.setState({ score: -1  });
        }
        
    }

    // start match
    startMatch = (e) => {
        this.setState({ text: e.target.value  });
        let text = e.target.value
        if(this.findText(text)){
           this.setState({ isPlaying: true  });
           this.setState({ timeElapsed: 0  });   
            
            this.showWord(this.state.words)
            e.target.value = ""
            let score = this.state.score ;
            score ++
            this.setState({ score : score }); 
            this.setState({ currentscore: score  });
            this.setState({ start: new Date() });
            this.setState({ isPlaying: false });
        }
    }

    //Match word
    findText(text) { 
        let wordinput = text ;
        let currentword = this.state.currentword ;
       
        if( wordinput === currentword){
            this.setState({ message: "Correct !!"  }); 
            return true
        }else {
            this.setState({ message: ''  });
            return false
        }
    }

    // Lifecycle
    componentDidMount() {
        this.interval = setInterval(this.elapsedTime.bind(this), 1000);
        this.interval = setInterval(this.checkStatus.bind(this), 50)
        this.setState({ start: new Date() });
    }

    easy =() => { this.setState({ levelsecond: 5  }); }
    medium = () => { this.setState({ levelsecond: 3  });}
    hard = () => {this.setState({ levelsecond: 2  });}
    render() { 
        const {currentword, message, currentscore , levelsecond} = this.state
        return ( 
                <div className="App">
                  <div className="container">

                      <div className="btn-group">
                        <p className="levels">levels : </p>
                        <button className="easy" onClick={this.easy}>Easy</button>
                        <button className="medium" onClick={this.medium}>Medium</button>
                        <button className="hard" onClick={this.hard}>Hard</button>
                      </div>
                      <p>Type The Given Word Within <span className="time">{levelsecond}</span> Seconds</p>
                    <p className="word">{currentword}</p>
                    <form>
                        <input 
                        name="text"
                        type="text"
                        placeholder="Start typing..." 
                        onChange={this.startMatch}
                        className="input"/>
                    </form>
                    <div className="true">
                        <p>{message}</p>
                    </div>
                    <div className="wrapper">
                       <p>Time Left: {this.timer(this.state.timeElapsed)}</p> 
                       <p>Score: {currentscore}</p>
                    </div>
                    
                    <div className="instructor">
                        <h3>Instructions!</h3>
                        <p>Type each word in the given amount of seconds to score . To play again just type the current word . Your score will reset.</p>
                    </div>
                  </div>
                  
              </div>
         );
    }
}
 
export default Main;